import cx from 'classnames'
import React from 'react'

import styles from './Button.module.scss'

export type RadixPropsVariant =
  | 'classic'
  | 'solid'
  | 'soft'
  | 'surface'
  | 'outline'
  | 'ghost'
export type NewVariant = 'primary' | 'secondary' | 'tertiary' | 'neutral'

// Temporary mapping to ensure backwards compatibility with Radix variants
export const VARIANT_MAP: Record<RadixPropsVariant | NewVariant, NewVariant> = {
  classic: 'primary',
  solid: 'primary',
  soft: 'tertiary',
  surface: 'tertiary',
  outline: 'tertiary',
  ghost: 'neutral',
  primary: 'primary',
  secondary: 'secondary',
  tertiary: 'tertiary',
  neutral: 'neutral'
}

export type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: RadixPropsVariant | NewVariant
  size?: 1 | 2 | 3 | '1' | '2' | '3'
  warning?: boolean
  children: React.ReactNode
}

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      variant = 'primary',
      size = '2',
      warning = false,
      className,
      children,
      ...props
    },
    ref
  ) => {
    return (
      <button
        className={cx(
          styles.button,
          styles[`button--${VARIANT_MAP[variant]}`],
          styles[`button--size${String(size)}`],
          className
        )}
        data-warning={warning}
        ref={ref}
        {...props}
      >
        {children}
      </button>
    )
  }
)

Button.displayName = 'Button'
